import { ApiFilterBase } from "@skailer-com/uikit/core";

import { SelectItem } from "@skailer-com/uikit";

export interface ApiDivision {
  id: number;
  title: string;
  employees_count: number;
}

export interface ApiDivisionFilter extends ApiFilterBase {
  text?: string;
}

export interface ApiDivisionShort extends SelectItem {
  id: number;
  is_archived: boolean;
}

export const ApiDivisionsFilterDefault: ApiDivisionFilter = {
  page_number: 1,
  text: "",
};
